// SmsPartsNote.tsx · v12.10.31 (#2295 "This text will send as 70-character parts" under a wording / template - the text is never changed) · 2026-11-05 · VoiceSpectrum AI
import { nonGsmChars } from '../../lib/smsParts';

/** Shown under a per-language text editor: one line per language whose text holds a character outside the standard text set. */
export default function SmsPartsNote({ texts, defaults }: { texts: Record<string, string>; defaults?: Record<string, string> }) {
  const langs = Array.from(new Set([...Object.keys(defaults ?? {}), ...Object.keys(texts ?? {})]));
  const hits = langs.map((l) => ({ l, chars: nonGsmChars(texts?.[l] ?? defaults?.[l] ?? '') })).filter((h) => h.chars.length > 0);
  if (hits.length === 0) return null;
  return (
    <div className="tx-row-sub sms-parts-note" data-testid="sms-parts-note" style={{ color: '#475569' }}>
      {hits.map((h) => (
        <div key={h.l}>
          <b>{h.l.toUpperCase()}</b>: This text will send as 70-character parts
          {h.l !== 'zh' && <> (because of {h.chars.slice(0, 4).map((c) => `“${c}”`).join(' ')}{h.chars.length > 4 ? ' …' : ''} - a plain keyboard apostrophe or quote keeps 160)</>}
          {h.l === 'zh' && <> (Chinese always sends as 70-character parts)</>}
        </div>
      ))}
    </div>
  );
}
